// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PagesRouteImport } from './routes/_pages'
import { Route as SplatRouteImport } from './routes/$'
import { Route as Error500RouteImport } from './routes/_error/500'
import { Route as Error404RouteImport } from './routes/_error/404'
import { Route as Error403RouteImport } from './routes/_error/403'
import { Route as PagesIndexRouteImport } from './routes/_pages/index'
import { Route as PagesSolarRouteImport } from './routes/_pages/solar'
import { Route as PagesResumeRouteImport } from './routes/_pages/resume'
import { Route as PagesProjectsRouteImport } from './routes/_pages/projects'
import { Route as PagesDataRouteImport } from './routes/_pages/data'
import { Route as PagesContributionsRouteImport } from './routes/_pages/contributions'
import { Route as PagesContactRouteImport } from './routes/_pages/contact'
import { Route as PagesBlogIndexRouteImport } from './routes/_pages/blog/index'
import { Route as PagesBlogPathRouteImport } from './routes/_pages/blog/$path'
import { Route as PagesDataSolarRouteImport } from './routes/_pages/data/solar'

const PagesRoute = PagesRouteImport.update({
            id: '/_pages',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const Error500Route = Error500RouteImport.update({
            id: '/_error/500',path: '/500',getParentRoute: () => rootRouteImport
          })
const Error404Route = Error404RouteImport.update({
            id: '/_error/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const Error403Route = Error403RouteImport.update({
            id: '/_error/403',path: '/403',getParentRoute: () => rootRouteImport
          })
const PagesIndexRoute = PagesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PagesRoute
          })
const PagesSolarRoute = PagesSolarRouteImport.update({
            id: '/solar',path: '/solar',getParentRoute: () => PagesRoute
          })
const PagesResumeRoute = PagesResumeRouteImport.update({
            id: '/resume',path: '/resume',getParentRoute: () => PagesRoute
          })
const PagesProjectsRoute = PagesProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => PagesRoute
          })
const PagesDataRoute = PagesDataRouteImport.update({
            id: '/data',path: '/data',getParentRoute: () => PagesRoute
          })
const PagesContributionsRoute = PagesContributionsRouteImport.update({
            id: '/contributions',path: '/contributions',getParentRoute: () => PagesRoute
          })
const PagesContactRoute = PagesContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => PagesRoute
          })
const PagesBlogIndexRoute = PagesBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => PagesRoute
          })
const PagesBlogPathRoute = PagesBlogPathRouteImport.update({
            id: '/blog/$path',path: '/blog/$path',getParentRoute: () => PagesRoute
          })
const PagesDataSolarRoute = PagesDataSolarRouteImport.update({
            id: '/solar',path: '/solar',getParentRoute: () => PagesDataRoute
          })





const PagesDataRouteChildren = {
  PagesDataSolarRoute: PagesDataSolarRoute
}

const PagesDataRouteWithChildren = PagesDataRoute._addFileChildren(PagesDataRouteChildren)



const PagesRouteChildren = {
  PagesContactRoute: PagesContactRoute,PagesContributionsRoute: PagesContributionsRoute,PagesDataRoute: PagesDataRouteWithChildren,PagesProjectsRoute: PagesProjectsRoute,PagesResumeRoute: PagesResumeRoute,PagesSolarRoute: PagesSolarRoute,PagesIndexRoute: PagesIndexRoute,PagesBlogPathRoute: PagesBlogPathRoute,PagesBlogIndexRoute: PagesBlogIndexRoute
}

const PagesRouteWithChildren = PagesRoute._addFileChildren(PagesRouteChildren)

const rootRouteChildren = {
  SplatRoute: SplatRoute,PagesRoute: PagesRouteWithChildren,Error403Route: Error403Route,Error404Route: Error404Route,Error500Route: Error500Route
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)